import SkipForwardButton from './SkipForwardButton';

export default SkipForwardButton;
